import React, { PureComponent } from "react";
import moment from "moment";
import _ from "i18n";

import { PERIODS_UNITS } from "Config";

import { TiArrowSortedDown } from "react-icons/ti";
import { SingleDatePicker } from "react-dates";

import styles from "./CollaboratorSpace.local.scss";

class CollaboratorSpaceFilter extends PureComponent {
  //******************   Content Functions  **************//

  constructor(props) {
    super(props);

    this.state = {
      loading: false
    };
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsidePeriodFilter.bind(this)
    );
  }

  setPeriodWrapperRef(node) {
    this.periodWrapperRef = node;
  }

  handleClickOutsidePeriodFilter(event) {
    if (
      this.periodWrapperRef &&
      !this.periodWrapperRef.contains(event.target)
    ) {
      this.setState({ periodsFilterIsVisible: false });
    }
  }

  handleDisplayPeriodeFilter = () => {
    this.setState(state => {
      return {
        periodsFilterIsVisible: !state.periodsFilterIsVisible
      };
    });
  };

  renderTabFilter = () => {
    return (
      <div className={styles.filter_dossier}>
        {PERIODS_UNITS.map(item => (
          <span
            key={`period-${item.value}`}
            className={
              this.props.period === item.value
                ? styles.active_vue
                : styles.inactive_vue
            }
            onClick={
              this.props.period !== item.value
                ? () => this.handleActivateTab(item.value)
                : null
            }
          >
            {item.label}
          </span>
        ))}
      </div>
    );
  };

  renderSelectPeriodFilter = () => {
    let { periodsFilterIsVisible } = this.state;
    let { arrivalDate, date } = this.props;

    return (
      <div style={{ display: "flex" }}>
        <div
          ref={this.setPeriodWrapperRef.bind(this)}
          className={
            styles.customed_select +
            " " +
            styles.change_position +
            " " +
            (periodsFilterIsVisible ? styles.customed_select_opened : "")
          }
          style={{ width: 270 }}
        >
          <div className={styles.customed_select_header}>
            <div className={styles.title_bar_title}>
              {_("fromDate")}{" "}
              {arrivalDate &&
              arrivalDate.format("Y-MM-DD") >
                (date && date.format("Y-01-01")) ? (
                <span>{arrivalDate.format("DD-MM-Y")}</span>
              ) : (
                <span>{(date && date.format("01-01-Y")) || "null"}</span>
              )}
              {_(" ")}
              {_("to")} <span>{date && date.format("DD-MM-Y")}</span>
            </div>
            <div className={styles.actions}>
              <div>
                <span
                  className={styles.action}
                  onClick={this.handleDisplayPeriodeFilter}
                >
                  <TiArrowSortedDown />
                </span>
              </div>
            </div>
          </div>
          {periodsFilterIsVisible && (
            <div className={styles.customed_select_body}>
              <div className={styles.customed_select_body_options}>
                <div
                  id="single-date-calendar"
                  className={styles.filter_frame_field}
                >
                  <SingleDatePicker
                    id="your_unique_id"
                    date={this.props.date}
                    isOutsideRange={day =>
                      day.isAfter(new moment()) ||
                      (arrivalDate && day.isBefore(arrivalDate))
                    }
                    displayFormat={() => "DD/MM/YYYY"}
                    onDateChange={this.handleChangeFilterDate}
                    focused={periodsFilterIsVisible}
                    onFocusChange={({ focused }) => this.setState({ focused })}
                    numberOfMonths={1}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  handleActivateTab = period => {
    this.props.onChangeFilter(period, null, null);
  };

  handleChangeFilterDate = date => {
    this.props.onChangeFilter(null, date, null);
    this.setState({ periodsFilterIsVisible: false });
  };

  render() {
    return (
      <div className={styles.filter_block}>
        {this.renderTabFilter()}
        {this.renderSelectPeriodFilter()}
      </div>
    );
  }
}

export default CollaboratorSpaceFilter;



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorSpaceFilter.js